<template>
  <div class="account">
    <a-modal :visible="visible" @cancel="visible = false" title='车辆' width='460px' @ok='sub'>
      <a-row align='middle' justify='space-between' type='flex'>
        <label>业务类型名称：</label>
        <a-input placeholder='请输入业务类型名称' v-model='smlform.title' style="width:300px;"> </a-input>
      </a-row>
    </a-modal>
    <div class="top wbg" v-if='$common.AUTH("car:index")'>
      <div class="group">
        <a-form-model ref="ruleForm" :model="form">
          <div class="label">
            业务类型名称：
            <a-input v-model="form.title" placeholder='请输入业务类型名称' style="width: 167px;"> </a-input>
          </div>
          <div class="allbtns">
            <a-button icon="search" @click="query(1)" style="height:30px;">查询</a-button>
            <a-button style="min-width: 64px;" @click="reset">重置</a-button>
            <a-button icon="plus" @click="smlform.title = null; smlform.id = null; visible = true;"
              v-if='$common.AUTH("car:add")' style="height:32px;">新增</a-button>
          </div>
        </a-form-model>
      </div>
    </div>
    <div class="tcon wbg" v-if='$common.AUTH("car:index")'>
      <ul>
        <!-- <a-table rowKey="id" :columns="columns" :data-source="data" :pagination="page" @change="query">

          <div slot="alist" slot-scope="text, record">
            <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(record.id)'>
              <a href='javascript:void(0);'>删除</a>
            </a-popconfirm>
            <span class="line"></span>
            <a href='javascript:void(0);' @click='smlform=JSON.parse(JSON.stringify(record));visible=true;'>修改</a>
          </div>
        </a-table> -->
        <li v-for='(record, index) in data' :key='index'>
          <div class="thead">
            <div class="td">业务类型名称</div>
            <div class="td">操作</div>
          </div>
          <div class="tbody">
            <div class="td">{{ record.title }}</div>
            <div class="td">
              <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(record.id)'
                v-if='$common.AUTH("car:del")'>
                <a href='javascript:void(0);'>删除</a>
              </a-popconfirm>
              <span class="line"></span>
              <a href='javascript:void(0);' @click='smlform = JSON.parse(JSON.stringify(record)); visible = true;'
                v-if='$common.AUTH("car:edit")'>修改</a>
            </div>
          </div>
        </li>
      </ul>
      <div class="pages">
        <a-pagination v-model="form.page" :total="total" show-less-items :pageSize='20' show-quick-jumper
          @change='turnpage' :show-total="total => `小计 ${total}`" />
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import { carAdd, carList, carEdit, carDel } from '@/server/api'
export default {
  data() {
    return {
      smlform: { title: '' },
      form: { title: '', page: 1, limit: 20 },
      visible: false,
      data: [],
      total: 0
    }
  },
  created() {
    this.query()
  },
  methods: {
    del(id) {
      carDel({ "id": id }).then(e => {
        this.$message.success({ content: '删除成功' })
        this.query()
      })
    },
    sub() {
      if (this.smlform.id) {
        carEdit(this.smlform).then(e => {
          this.$message.success({ content: '修改成功' })
          this.visible = false
          this.query()
        })
      } else {
        carAdd({ title: this.smlform.title }).then(e => {
          this.$message.success({ content: '新增成功' })
          this.visible = false
          this.query()
        })
      }
    },
    turnpage(val) {
      this.form.page = val;
      this.query()
    },
    query(val) {
      carList(this.form).then((res) => {
        this.data = res.list
        this.total = res.count
      })
    },
    reset() {
      this.form.limit = 20
      this.form.page = 1
      this.form.title = ''
      this.query()
    }
  }
}
</script>
<style lang="less" scoped>
.account {
  @import url("@/assets/css/topForm");
}

.tcon {
  padding: 0 20px;
  min-height: 760px;

  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      width: 32.5%;
      border: 1px solid #efefef;
      margin-right: 1.25%;
      margin-bottom: 20px;

      .thead {
        border-bottom: 1px solid #efefef;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 36px;
        background: #f4f5f9;

        .td {
          flex: 1;
          display: flex;
          justify-content: center;
          font-size: 0.875rem;
          color: #102b4b;
          height: 36px;
          align-items: center;

          &:nth-child(1) {
            border-right: 1px solid #efefef;
          }
        }
      }

      .tbody {
        display: flex;
        align-items: center;
        justify-content: center;

        .td {
          height: 54px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;

          &:nth-child(1) {
            border-right: 1px solid #efefef;
          }

          .line {
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: #dbdcde;
            margin: 0 10px;
            vertical-align: middle;
          }
        }
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}

.modal-footer {
  text-align: center;

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
